import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

const pedidoAlteracaoNomeCertificadoExameOrdemConfig = {
  id: 'pedido_alteracao_nome_certificado_exame_ordem',
  nome: 'Pedido de Alteração de Nome no Certificado de Aprovação do Exame de Ordem',
  categoria: 'pedidos',
  descricao: 'Solicitação de alteração de nome no certificado de aprovação do Exame de Ordem',
  icon: 'FaCertificate',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true },
      { id: 'RG', tipoDocumentoProcesso: 533, name: 'RG', description: 'Cópia digitalizada do RG atualizado, evidenciando o nome a constar no certificado', required: true }
    ]
  },

  paymentConfig: {
    amount: 27.00
  },

  protocoloConfig: {
    modeloRequerimento: '315',
    tiposAssunto: '832',
    tipoPedido: '505'
  },

  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'nomeCompleto', campoNome: 'Nome' },
        { field: 'cpf', campoNome: 'CPFCNPJ' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
  ),

  tituloConfig: {
    tipoLancamentoId: 155,
    enderecoOrigem: 'residencial'
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { type: 'text', name: 'nomeCompleto', label: 'Nome completo', required: true, placeholder: 'Digite seu nome completo' },
            { type: 'cpf', name: 'cpf', label: 'CPF', required: true }
          ]
        }
      ]
    },
    enderecoStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoAlteracaoNomeCertificadoExameOrdemConfig;
